import CommonLayout from "./CommonLayout";
import React, { useEffect, useMemo } from "react";
import { useUserSessionStore } from "stores/UserSession.store";
import { useServices } from "../../hooks/collections/useServices";
import { useServicesStore } from "../../stores/Services.store";
import { IService } from "../../@core/interfaces/IService";
import { NotFound } from "../../components/NotFound/NotFound";
import schoonLogo from "images/schoon_transparent.svg";

const AccountProviderServices = () => {
  const user = useUserSessionStore((state) => state.user);
  const { services, populatedServices } = useServices(true);
  const setServicesPopulated = useServicesStore((state => state.setServices));
  const servicesPopulated = useServicesStore((state => state.services));

  const displayData = useMemo(() => {
    return servicesPopulated.filter((service: IService) => service.details.provider.id === user.id);
  }, [servicesPopulated]);

  const handleSetServicesPopulated = async () => {
    setServicesPopulated(await populatedServices(services));
  };

  useEffect(() => {
    handleSetServicesPopulated();
  }, [services]);

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Provider Services</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 min-h-96">
          {displayData.length === 0 ? (
            <NotFound description={"There are no services assigned to you."}/>
          ) : (
            displayData.map((service: IService) => (
              <div
                key={service.id}
                className="flex flex-col border rounded-lg p-4 dark:border-neutral-700 h-fit bg-white dark:bg-gray-800"
              >
                <img
                  src={service?.images.length ? service.images[0] : schoonLogo}
                  alt={service.title}
                  className="w-full h-32 object-cover rounded-lg mb-4"/>
                <div>
                  <h3 className="text-xl font-semibold">{service.title}</h3>
                  <p className="text-sm text-neutral-400">{service.details.location.address}</p>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    );
  };

  return (
    <CommonLayout>{renderSection1()}</CommonLayout>
  );
}

export default AccountProviderServices
